const accounting = {
  accounting: 'Бухгалтерская отчетность',
  accountingSheet: 'Бухгалтерский баланс',
  total: 'Итого',
  amount: 'Сумма',
  requestedAmount: 'Запрашиваемая сумма',
  requestedTerm: 'Запрашиваемый срок',
  summ: 'Сумма',
  revenue: 'Выручка',
  markup: 'Наценка',
  grossProfit: 'Валовая прибыль',
  grossProfitShort: 'ВП',
  payments: 'Платежи',
  period: 'Период',
  maxOverdueReceivable: 'Макс. проср. ДЗ',
  maxOverdueReceivableShort: 'Макс. ПДЗ',
  maxDaysPastDue: 'Макс. дни просрочки',
  maxDaysPastDueShort: 'Макс. ПДН',
  receivableEndOfPeriod: 'ДЗ на конец периода',
  receivableEndOfPeriodShort: 'ДЗ',
  maxAccountsReceivableAtEndOfPeriod: 'Макс. ДЗ на конец периода',
  contractLimit: 'Лимит по договору',
  limit: 'Лимит',
  contractDays: 'Отсрочка по контракту',
  holdingRevenue: 'Выручка по холдингу',
  holdingGrossProfit: 'Валовая прибыль по холдингу',
  nonCurrentAssets: 'Внеоборотные активы',
  currentAssets: 'Оборотные активы',
  capitalAndReserves: 'Капитал и резервы',
  longTermLiabilities: 'Долгосрочные обязательства',
  shortTermLiabilities: 'Краткосрочные обязательства',
  activityRevenuesAndExpenses: 'Доходы и расходы по обычным видам деятельности',
  otherRevenuesAndExpenses: 'Прочие доходы и расходы',
  financeReference: 'Справочно',
  balanceSheet: 'Бухгалтерский баланс',
  incomeStatement: 'Отчет о финансовых результатах',
};

export default accounting;
